// Note: bottom-up, and the uppermost path takes the hover. Each shape sits above the one that contains it,
// so a road wins over the fence it runs through, a pattern over its pit and a block over its pattern.
export const LAYER_RANK = {
  features: 0,
  fences: 1,
  roads: 2,
  patterns: 3,
  blocks: 4,
  machines: 5,
} as const;

export function stackOrder<T>(groups: Map<number, T>): T[] {
  return [...groups.entries()].sort(([a], [b]) => a - b).map(([, group]) => group);
}
